import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import { xwjStore } from './store/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/reset.scss'
import './assets/css/style.css'
import PubSub from 'pubsub-js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'ant-design-vue/dist/antd.css'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import { v4 as uuidv4 } from 'uuid'
import VueLazyload from 'vue-lazyload'
import { MessageBox } from 'element-ui'
import Vant from 'vant'
import 'vant/lib/index.css'
import config from './common/config'

// 注册UI组件库
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.use(VideoPlayer)
Vue.use(Vant)

// 配置图片懒加载
Vue.use(VueLazyload, {
  preLoad: 1, // 完全显示的时候加载
  error: require('./assets/img/error.png'), // 失败时显示的图片
  loading: require('./assets/img/loading.gif'), // 加载时显示的GIF图
  attempt: 1 // 尝试加载几次
})

// 全局事件总线
const bus = new Vue()
Vue.prototype.bus = bus

// 全局状态管理
Vue.prototype.xwjStore = xwjStore

// 发布订阅
Vue.prototype.$PubSub = PubSub

// 关闭生产环境提示
Vue.config.productionTip = false

// 全局工具方法
Vue.prototype.$uuidv4 = uuidv4
Vue.prototype.$http = axios
Vue.prototype.$confirm = MessageBox.confirm

// 应用配置（从config中读取，避免硬编码）
Vue.prototype.$appKey = config.appKey || ''
Vue.prototype.$appSecret = config.appSecret || ''
Vue.prototype.imgserver = config.fileUrl || ''
// 自定义指令：移除aria-hidden属性
Vue.directive('removeAriaHidden', {
  bind(el) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})

// RSA加密签名工具方法
Vue.prototype.$getRSASign = function (password, key) {
  if (!key || !password) {
    console.error('RSA加密参数缺失')
    return null
  }
  try {
    const sign = new JSEncrypt({
      default_key_size: 1024
    })
    // 清理并格式化公钥
    const cleanedKey = key.replace('/r', '').trim()
    const formattedKey = `-----BEGIN PUBLIC KEY-----${cleanedKey}-----END PUBLIC KEY-----`
    sign.setPublicKey(formattedKey)
    const encryptedData = sign.encrypt(password.toString())
    return encryptedData
  } catch (error) {
    console.error('RSA加密失败:', error)
    return null
  }
}

// 创建Vue实例
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
